import Tooltip from "rc-tooltip";
import React, { useMemo } from "react";
import { useTransmitScales } from "../context/transmitScales";
import { Hotspot, HotspotLocation } from "../utils/types";

interface Props {
  className?: string;
  hotspot?: Hotspot;
  location?: HotspotLocation;
  withoutCustomRewardScaling?: boolean;
  withoutTooltip?: boolean;
}

const StatusDot: React.FC<Props> = ({
  className,
  hotspot,
  location,
  withoutCustomRewardScaling,
  withoutTooltip,
  ...otherProps
}) => {
  const { isTransmitScaleActive } = useTransmitScales();

  const [outerColorClass, innerColorClass, tooltipText] = useMemo(() => {
    let text = "";

    if (hotspot) {
      text += `Hotspot is ${hotspot.online ? "active" : "inactive"}.`;
    }

    const id = hotspot?.id || location?.uuid;

    if (id && !withoutCustomRewardScaling) {
      if (!isTransmitScaleActive(id)) {
        return [
          "bg-gray-100 bg-opacity-50",
          "bg-gray-400",
          text + "\nManually disabled for reward scaling"
        ];
      }
    }

    if (location) {
      text = "Location is used for reward scaling";
    }

    return hotspot && !hotspot.online
      ? ["bg-red-100 bg-opacity-50", "bg-red-400", text]
      : ["bg-green-100 bg-opacity-50", "bg-green-400", text];
  }, [hotspot, isTransmitScaleActive, location, withoutCustomRewardScaling]);

  const renderContent = useMemo(
    () => (
      <span
        className={`h-4 w-4 rounded-full flex items-center justify-center ${outerColorClass} ${
          className || ""
        }`}
        aria-hidden="true"
        {...otherProps}
      >
        <span className={`h-2 w-2 rounded-full ${innerColorClass}`} />
      </span>
    ),
    [className, innerColorClass, otherProps, outerColorClass]
  );

  if (withoutTooltip) return renderContent;

  return (
    <Tooltip placement="top" overlay={tooltipText}>
      {renderContent}
    </Tooltip>
  );
};

export default StatusDot;
